import { Component, OnInit, ViewChild } from '@angular/core';
import { EquipmentService } from 'src/app/services/equipment.service'
import { TicketsService, PayrollCodeService, SqacodeService,MessageService, QuestionsService, SqasubcodeService, ServicerequestService } from 'src/app/services'
import { SelectItem } from 'primeng/api/selectitem';
import { CreateTicketFormFields } from 'src/app/models/tickets/createTicketFormFields'
import { BartTicketSave } from 'src/app/models/tickets/bart.ticket.save'
import { BartTicketValidate } from 'src/app/models/tickets/bart.ticket.validate'
import { BartTicketSummary } from 'src/app/models/tickets/bart.ticket.summary'
import { BartTicket } from 'src/app/models/tickets/bart.ticket'
import { ConfirmationService } from 'primeng/api';
import {PartsUsedComponent } from '../partsUsed/parts-used.component'
  import { from } from 'rxjs';
@Component({
  selector: 'bart-ticket-info',
  templateUrl: './ticket-info.component.html',
  styleUrls: ['./ticket-info.component.scss']
})
export class TicketInfoComponent implements OnInit {
  @ViewChild(PartsUsedComponent,{static:false}) PartsUsedComponent:PartsUsedComponent;
  public formFields: CreateTicketFormFields;
  public showLoader: boolean = false;
  FacilityEquipmentColumns: any[];
  FacilityEquipmentData: any[] = [];
  selectedEquipmentData:any[];
  hours: SelectItem[];
  minutes:SelectItem[];
  paydata: SelectItem[];
  SQAdata: SelectItem[];
  SQASubdata: SelectItem[];
  questionData: SelectItem[];
  public showSectionName: string = ""
  public enableReason: boolean = false;
  public reasonTextRow: boolean = false;
  public enableSubcode: boolean = false;
  public displayPartsDialog: boolean = false;
  public displayTestEquipmentDialog: boolean = false;
  public showPaginator=false;
  public SrConfirmation:boolean=false;
  SqaCodeParama = {
    EquipmentID: null
  }
  questionsParams = {
    EquipmentID: null,
    DateServiceProvided: ''
  }
  sqaSubCodeParams = {
    SQACodeID: null,
    isSQACode:1
  }
  equipParams: any = {
    facilityMasterId: 1,
    searchTerm: '',
    equipmentStatusId: 1,
    equipmentTypeId: '',
    equipmentSubTypeId: '',
    modelId: ''
  };
  public ShowVoidDailoge: boolean = false;
  public showTicketSummaryDailoge: boolean = false;
  constructor(
    private _equipmentService: EquipmentService,
    public _ticketsService: TicketsService,
    private _payrollCodeService: PayrollCodeService,
    private _sqacodeService: SqacodeService,
    private _questionsService: QuestionsService,
    private _sqasubcodeService: SqasubcodeService,
    private _bartTicketSave: BartTicketSave,
    private _ticketValidate: BartTicketValidate,
    private _bartTicketSummary: BartTicketSummary,
    private _confirmationService: ConfirmationService,
    private _bartTicket: BartTicket,
    private _ServicerequestService: ServicerequestService,
    private _messageService:MessageService
  ) {
    this.formFields = new CreateTicketFormFields();

  }
  ngOnInit() {
    this.getPayrollCodes();
    this._ticketsService.getTicketGlobalData().subscribe((Result: any) => {
      this.formFields = Result;
      
    },
      (respose: Response) => {
        // handle error here
      }
    );
    this.FacilityEquipmentColumns = [
      { field: 'EquipmentID', header: 'Equipment ID', display: 'none' },
      { field: 'EquipmentTypeDescription', header: 'Equipment Type' },
      { field: 'ManufacturerName', header: 'Manufacturer' },
      { field: 'modelNumber', header: 'Model' },
      { field: 'EquipmentSubTypeDescription', header: 'Sub-Type' },
      { field: 'EquipmentSerialNumber', header: 'Serial#' },
      { field: 'equipmentDescription', header: 'Description' },
      { field: 'hasClockText', header: 'Has Clock' },
    ];
    this.hours = [];
    for (let i = 0; i <= 24; i++) {
      let j = 0;
      if (i <= 9) {
        this.hours.push({ label: j + i.toString(), value: i });
      }
      else { this.hours.push({ label: i.toString(), value: i }); }

    }
    this.minutes=[];
    this.minutes.push({ label: "00", value: 0},{ label: "15", value: 25},{ label: "30", value: 50},{ label: "45", value: 75}); 
    this.formFields.hoursWorkedSel = Number(0);
    this.formFields.hoursTravelSel = Number(0);
    this.formFields.minutesTravelSel = Number(0);
    this.formFields.minutesWorkedSel = Number(0);
    //this.getBatchFacilityEquipment();
    // this._ticketsService.getData().subscribe((Result: any) => {


  }

  public getBatchFacilityEquipment() {
    this.showLoader = true; 
    var GETFACILITYEQUIPMENT = this.equipParams;
    this._equipmentService.getFacilityEquipment(JSON.stringify({ GETFACILITYEQUIPMENT }))
      .subscribe((Result: any) => {
        
       //Bart enhancement 2020 - Remove qouates from start ane end EquipmentSerialNumber (SPR-1402)-- starts here
        Result.facilityEquipment.forEach(function(item, i) {  Result.facilityEquipment[i].EquipmentSerialNumber = Result.facilityEquipment[i].EquipmentSerialNumber.replace(/"/g, '');});
       //Bart enhancement 2020 - Remove qouates from start ane end EquipmentSerialNumber (SPR-1402)-- ends here

        this.selectedEquipmentData=[];
        this.FacilityEquipmentData = Result.facilityEquipment;
        this.showLoader = false;
        if (this.FacilityEquipmentData.length <= 0) {
          this._messageService.showAlertMessage("No equipment found for this location");
          this.showPaginator=false;
        }
        if(this.FacilityEquipmentData.length>20)
        {
          this.showPaginator=true;
        }
      },
        (error) => {
          this.showLoader = false;
          // handle error here
        }
      );
  }
  public OnRowFEClick(Rowid: number) {
    this.ClearFormFields(); //Addd By Harikesh on 21-July-2020
    this.showSectionName = "";
    this.formFields.selectedEquipmentList = this.selectedEquipmentData;
    this.formFields.SelectedEquipmentID = this.formFields.selectedEquipmentList["EquipmentID"];
    this.SqaCodeParama.EquipmentID = this.formFields.SelectedEquipmentID;
    this.questionsParams.EquipmentID = this.formFields.SelectedEquipmentID;
    this.formFields.lastRecordedHours=this.formFields.selectedEquipmentList["LastClockHours"];
    this.formFields.hasclock=this.formFields.selectedEquipmentList["hasClock"]
    this.pickEquipment(this.questionsParams.EquipmentID);
    this._ticketsService.setTicketGlobalData(this.formFields)
    this.getSQACodes();
  }
  //Start:Addd By Harikesh on 21-July-2020
  public ClearFormFields()
  {
    this.formFields.srRequestedDate=null;
    this.formFields.isDateServiceRequestedDisabled=false;
    this.formFields.srBeginDate=null;
    this.formFields.srCompletedDate=null;
    //Clear Labour details
    this.formFields.hoursTravelSel=0;
    this.formFields.hoursWorkedSel=0;
    this.formFields.minutesTravelSel=0;
    this.formFields.minutesWorkedSel=0;
    this.formFields.totalHours=0;
    this.formFields.totalMinutes=0;
    this.formFields.serviceRequested=null;
    this.formFields.findings=null;
    this.formFields.isServiceMatchFindingsFlag=null
    this.formFields.workPerformed=null;
    // Alert Box Details
    this.formFields.alertBox=null;
    this.formFields.partsUsedDuringRepair=null;
    this.formFields.ispartsUsedRadio=null;
    this.formFields.testEquipmentUsedDuringRepair=null;
    this.formFields.istestEquipUsedRadio=null;
    this.formFields.selectedpayRollId=null;
    this.formFields.selectedSQACodeId=null;
    this.formFields.selectedSQASubCodeId=null;
    this.formFields.ismeritComplaint=null;
    this.formFields.clockHours=null
    this.formFields.selectedQuestionId=null;
    this.formFields.responseComment=null;
    this.formFields.partTotalAmount='$0.00';
  }
  //End:Addd By Harikesh on 21-July-2020
  public pickEquipment(Equipmentid: number) {
   this.checkWorkTypes(Equipmentid);
  }
  public checkWorkTypes(EquipmentID: number) {
    var IsValid = true
    var GETSERVICEREQUEST =
    {
      serviceRequestId: null,
      WorkTypeID: this.formFields.selectedWorkTypeId,
      sqaCodeId: null,
      equipmentId: EquipmentID,
      facilityMasterIdList: this.formFields.selectedFacilityId,
      RequestStatusID: 2,
      returnTotalCount: 1,
      returnAllRecords: 0,
      maxRecords: 200,
      orderBy: "dateServiceDue ASC, serviceRequestId ASC",
      searchTerm: null
    };
    this._ServicerequestService.getServiceRequest(JSON.stringify({ GETSERVICEREQUEST })).subscribe((Result: any) => {
      if (Result != null) {
        if (Result[0].fullCount > 0 && this.formFields.isBatchTicket != true) {
          this.SrConfirmation=true;
          this._confirmationService.confirm({
            message: 'There are pending SRs for the selected work type. Do you really want to create the ticket from scratch?',
            accept: () => {
              this.SrConfirmation=false;
            },
            reject: () => {
              this.showSectionName = "EquipmentList";
              this.formFields.selectedEquipmentList=null;
              this.selectedEquipmentData=[];
              this.SrConfirmation=false;
            }

          });
        }
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );

  }
  public getPayrollCodes() {
    this._payrollCodeService.getPayrollCodes(null)
      .subscribe((Result: any) => {
        if (Result.length > 0) {
          this.paydata = Result.map(data => ({
            label: data.payrollCodeDescription,
            value: data.payrollCodeId,
          }));
        }
      },
        (respose: Response) => {
          // handle error here
        }
      );
  }
  public getSQACodes() {
    this.formFields.isSQACodeDisabled=false
    this.SqaCodeParama.EquipmentID = this.formFields.SelectedEquipmentID;
    var GETEQUIPMENTSQACODES = this.SqaCodeParama;

    this._sqacodeService.getEquipmentSQACodes(JSON.stringify({ GETEQUIPMENTSQACODES })).subscribe((Result: any) => {
      if (Result.length > 0) {
        this.SQAdata = Result.map(data => ({
          label: data.SQADescription,
          value: data.SQACodeId,
        }));
        if(this.formFields.selectedWorkTypeName=="PM")
        {
          this.formFields.selectedSQACodeId=14
          this.formFields.isSQACodeDisabled=true
          this.SQACodeChanged();
        }
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );

  }
  public getSubSqaCodes() {
    this.sqaSubCodeParams.SQACodeID=this.formFields.selectedSQACodeId;
    var GETSQASUBCODES = this.sqaSubCodeParams;
    this.SQASubdata=[];
    this._sqasubcodeService.getSqaSubCodes(JSON.stringify({ GETSQASUBCODES })).subscribe((Result: any) => {
      if (Result.length > 0) {
        this.SQASubdata = Result.map(data => ({
          label: data.sqaSubDescription,
          value: data.sqaSubCodeId,
        }));
        this.enableSubcode=true;
      }
      else {
        this.enableSubcode=false;
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );

  }
  public getQuestions() {
    if(this.formFields.srCompletedDate!=null)
    {
      this.questionsParams.DateServiceProvided=this.formFields.srCompletedDate;
      var GETQUESTIONSBYEQUIPMENTID = this.questionsParams;
      this._questionsService.getQuestionsByEquipmentId(JSON.stringify({ GETQUESTIONSBYEQUIPMENTID })).subscribe((Result: any) => {
        if (Result.length > 0) {
          this.questionData = Result.map(data => ({
            label: data.Question,
            value: data.QuestionID,
          }));
          if (this.formFields.TicketId != null && this.formFields.TicketId > 0)
            this.loadTicketQuestions(this.formFields.TicketId);

        }
      },
        (respose: Response) => {
          // handle error here
        }
      );
    }
  }
  public showEquipmentList() {

    this.showSectionName = "EquipmentList"
    this.equipParams.facilityMasterId = this.formFields.selectedFacilityId;
    this.SqaCodeParama.EquipmentID = this.formFields.SelectedEquipmentID;
    this.questionsParams.DateServiceProvided = this.formFields.srCompletedDate;
    this.getBatchFacilityEquipment();

  }
  public showLabour() {
    this.showSectionName = "Labour"
  }

  public SQACodeChanged() {
    this.sqaSubCodeParams.SQACodeID = this.formFields.selectedSQACodeId;
    this.questionsParams.EquipmentID = this.formFields.SelectedEquipmentID;
    this.getSubSqaCodes();

  }
  public populateReason() {
    if (this.formFields.ismeritComplaint == "yes") {
      this.enableReason = true;
      // this.questionsParams.DateServiceProvided = this.formFields.srCompletedDate;
      // this.getQuestions();

    }
    else {
      this.reasonTextRow = false;
      this.enableReason = false;
    }
  }
  public OnreasonChanged() {
    if (this.formFields.selectedQuestionId != null && this.formFields.selectedQuestionId > 0) {
      let questionLabel = this.questionData.find(x => x.value == this.formFields.selectedQuestionId).label
      if (questionLabel == "Not Listed") {
        this.reasonTextRow = true;
      }
      else {
        this.formFields.responseComment = null;
        this.reasonTextRow = false;
      }
    }
    else { }
  }
  public testEquipmenRadioClicked() {
    if (this.formFields.istestEquipUsedRadio == "yes") {
      this.displayTestEquipmentDialog = true
    }
    else {
      this.displayTestEquipmentDialog = false
      this.formFields.testEquipmentUsedDuringRepair = null;
    }
  }
  
  public partUsedRadioClicked() {
      if (this.formFields.ispartsUsedRadio == "yes") {
      this.displayPartsDialog = true
      this.PartsUsedComponent.SearchButtonclick();
    if(this.formFields.partsUsedDuringRepair!=null && this.formFields.partsUsedDuringRepair!=undefined)
    {
      this.PartsUsedComponent.checkRGANumber()
      this.formFields.partsUsedDuringRepair=this.formFields.partsUsedDuringRepair.sort((a, b) => (parseInt(a.partNumber) > parseInt(b.partNumber) ? 1 : -1));
    }
    }
    else {
      this.displayPartsDialog = false
      this.formFields.partsUsedDuringRepair = null;
      this.formFields.partTotalAmount='$0.00';
    }
  }
  public hoursWorkAndTravel(Type:any) {
 
    if (Type == "Hours") {
      this.formFields.totalHours = Number(this.formFields.hoursWorkedSel) + Number(this.formFields.hoursTravelSel)
    }
    else {
      this.minutes=[];
      this.minutes.push({ label: "00", value: 0},{ label: "15", value: 25},{ label: "30", value: 50},{ label: "45", value: 75}); 
      this.formFields.totalMinutes = Number(this.minutes.find(x => x.value == this.formFields.minutesTravelSel).label) + Number(this.minutes.find(x => x.value == this.formFields.minutesWorkedSel).label)
      if(this.formFields.totalMinutes>=60)
      {
        this.formFields.totalHours=this.formFields.totalHours+1;
        this.formFields.totalMinutes=this.formFields.totalMinutes-60
      }
    }
  }
 voidButton() 
  {
    this.showLoader=true
    let tempTicketId=this.formFields.TicketId;
    this._bartTicketSave.saveTicket(false,(isShowAlert)=>{
      if(isShowAlert && (tempTicketId==null || tempTicketId==undefined || tempTicketId==0))
      {
        this._messageService.confirmThis("Success:Ticket Saved", ()=>
          {  
            this.ShowVoidDailoge = true;
          });
      }
      else
      {
        this.ShowVoidDailoge = true;
      }
      this.showLoader=false
    });
  }
  async closeButton() {
     let tempTicketId=this.formFields.TicketId;
    this.showLoader=true
    var colOneValid = await this._ticketValidate.validateColumn1(false);
    var ticketValid = false;
    var hoursOk = await this._ticketValidate.checkClockHours();
    if (hoursOk) 
    {
      this._bartTicketSave.saveTicket(false,(isSuccess)=>
      {
        if(isSuccess && (tempTicketId==null || tempTicketId==undefined || tempTicketId==0))
        {
          this._messageService.confirmThis("Success:Ticket Saved", ()=>
          {  
            if (colOneValid) 
            {
              ticketValid =  this._ticketValidate.validateStandardTicket();
            };
            if (ticketValid) 
            {
              // $('#column1,#column2,#column3').hide();
              this.showLoader=false
              this.formFields.isShowTicketSummary=true;      
            }
            else
            {
              this.showLoader=false
            }
          });
        }
        else
        {
          if (colOneValid) 
          {
            ticketValid =  this._ticketValidate.validateStandardTicket();
          };
          if (ticketValid) 
          {
            // $('#column1,#column2,#column3').hide();
            this.showLoader=false
            this.formFields.isShowTicketSummary=true;      
          }
          else
          {
            this.showLoader=false
          }
        }
      });
    }
    else
    {
      this.showLoader=false
    }
  }
  async saveButton() {
    this.showLoader=true
    //loader has to impliment later
    var hoursOk = await this._ticketValidate.checkClockHours();
    if (hoursOk) 
    {
      await this._bartTicketSave.saveTicket(true,(isSuccess)=>
      {
        this.showLoader=false
      });
    }
    else
    {
      this.showLoader=false
    }
  }
  public numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 46) {
      this._messageService.showAlertMessage("Current Hours must be a number and not contain a decimal.");
      this.formFields.clockHours = null;
      return false;
    }
    else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  public checkCurrentHours()
  {
     if(this.formFields.clockHours && isNaN(this.formFields.clockHours))
     {
       this._messageService.showAlertMessage("Current Hours must be a number and not contain a decimal.")
       this.formFields.clockHours=null
     }
     else if(this.formFields.clockHours && this.formFields.clockHours.toString().indexOf(".")!=-1)
     {
      this._messageService.showAlertMessage("Current Hours must be a number and not contain a decimal.")
      this.formFields.clockHours=null
     }
  }
  public saveVoid() {
    var voidReason = this.formFields.voidReason;

    // for what's left, let's strip newlines out and see if we end up with nothing
    var voidReasonNoCR = voidReason.replace(/^\s+|\s+$/g, '');

    if (voidReasonNoCR.length > 0) 
    {
      if (this.formFields.TicketId != undefined && this.formFields.TicketId != null) 
      {
        this._bartTicket.voidTicket();
        this.ShowVoidDailoge = false;
      };
    } 
    else 
    {
      this._messageService.showAlertMessage('You must provide a reason for voiding the ticket.');
    };
    
  }
 
  //#region Bart.Ticket.Load Js Code
  public loadTicketQuestions(ticketId) {
    let qCount: number = this.questionData.length;
    if (qCount > 1) {
      let loadTicketQuestionParam =
      {
        "LOADTICKETQUESTION": {
          TicketID: ticketId

        }
      }

      this._ticketsService.loadTicketQuestion(JSON.stringify(loadTicketQuestionParam)).subscribe(data => {
        if (data != null && data.length > 0) {
          this.formFields.ismeritComplaint = "yes";
          //this.populateReason();
          this.enableReason = true;
          this.formFields.selectedQuestionId = data[0].questionID
          this.OnreasonChanged();
          this.formFields.responseComment = data[0].responseComment
        }
        else {
          this.formFields.ismeritComplaint = "no";
          this.enableReason = true;
        }
      },
        (error) => {
          console.log(error);

        })
    }
  }
  ////#endregion   
}
